import moment from 'moment';

import { performGet } from '../services/rest-service/rest-service';

export const GET_WEB_TRAFFIC = 'web-traffic/GET_WEB_TRAFFIC';
export const GET_WEB_TRAFFIC_RECEIVED = 'web-traffic/GET_WEB_TRAFFIC_RECEIVED';
export const GET_WEB_TRAFFIC_ERROR = 'web-traffic/GET_WEB_TRAFFIC_ERROR';

const initialState = {
  loading: false,
  data: [],
  domain: '',
  total: 0,
};

const webTrafficReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WEB_TRAFFIC:
      return { ...state, loading: true };
    case GET_WEB_TRAFFIC_RECEIVED: {
      let total = 0;
      const traffic = action.payload.websiteTraffic;

      const data = Object.keys(traffic).map(key => {
        total += traffic[key];
        return { x: moment.utc(key, 'x').valueOf(), y: traffic[key] };
      });

      if (data) {
        data.sort((a, b) => {
          if (a.x < b.x) {
            return -1;
          }

          if (a.x > b.x) {
            return 1;
          }

          return 0;
        });
        const momentMostRecentData = moment.utc(data[data.length - 1].x);
        const limit = moment.utc().subtract(1, 'day');

        do {
          momentMostRecentData.add(1, 'day');
          data.push({
            x: momentMostRecentData.valueOf(),
            y: 0,
          });
          // The intention here is unclear, so just hide the linting error.
          // eslint-disable-next-line no-unmodified-loop-condition
        } while (momentMostRecentData < limit);
      }

      return {
        ...state,
        data,
        total,
        loading: false,
        domain: action.payload.domainName,
        alias: action.payload.alias,
      };
    }
    case GET_WEB_TRAFFIC_ERROR:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export const getTrafficDataByArticleId = (articleId, domainId) => dispatch => {
  dispatch({ type: GET_WEB_TRAFFIC });
  performGet('/api/article/website-traffic-data', { articleId, domainId })
    .then(resp =>
      dispatch({ type: GET_WEB_TRAFFIC_RECEIVED, payload: resp.data }),
    )
    .catch(error => dispatch({ type: GET_WEB_TRAFFIC_ERROR, payload: error }));
};

export default webTrafficReducer;
